import { useTheme } from "@mui/material";
import { ResponsiveBar } from "@nivo/bar";
import { tokens } from "../theme";

const BarChart = ({ isDashboard = false, data }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const dataset = []

  data.forEach((proposalGroup) => {
    proposalGroup.forEach((proposal) => {
      const { created_at, status, amount_total } = proposal.fields;
  
      const formattedDate = new Date(created_at).toLocaleDateString("en-GB");
  
      let entry = dataset.find((item) => item.data === formattedDate);
  
      if (!entry) {
        entry = {
          data: formattedDate,
          Aprovadas: 0,
          Rejeitadas: 0,
          Pendentes: 0,
          Finalizadas: 0,
        };
        dataset.push(entry);
      }
  
      if (status === "APPROVED") {
        entry.Aprovadas += parseFloat(amount_total);
      } else if (status === "REJECTED") {
        entry.Rejeitadas += parseFloat(amount_total);
      } else if (status === "CREATED") {
        entry.Pendentes += parseFloat(amount_total);
      } else if (status === "FINISHED") {
        entry.Finalizadas += parseFloat(amount_total);
      }
    });
  });

  dataset.sort((a, b) => {
    const dateA = new Date(a.data.split('/').reverse().join('/'));
    const dateB = new Date(b.data.split('/').reverse().join('/'));
  
    return dateA - dateB;
  });

  dataset.forEach((entry) => {
    entry.AprovadasColor = "#83d84d";
    entry.RejeitadasColor = "#ff5050";
    entry.PendentesColor = "#fff28b"; 
    entry.FinalizadasColor = "#ffffff"; 
  });
  
  return (
    <ResponsiveBar
      data={dataset}
      theme={{
        // added
        axis: {
          domain: {
            line: {
              stroke: colors.grey[100],
            },
          },
          legend: {
            text: {
              fill: colors.grey[100],
            },
          },
          ticks: {
            line: {
              stroke: colors.grey[100],
              strokeWidth: 1,
            },
            text: {
              fill: colors.grey[100],
            },
          },
        },
        legends: {
          text: {
            fill: colors.grey[100],
          },
        },
      }}
      keys={["Aprovadas", "Rejeitadas", "Pendentes", "Finalizadas"]}
      indexBy="data"
      margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
      padding={0.3}
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      colors={["#83d84d", "#ff5050", "#fff28b", "#ccc"]}
      defs={[
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: "#38bcb2",
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: "lines",
          type: "patternLines",
          background: "inherit",
          color: "#eed312",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      borderColor={{
        from: "color",
        modifiers: [["darker", "1.6"]],
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: isDashboard ? undefined : "country", // changed
        legendPosition: "middle",
        legendOffset: 32,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: isDashboard ? undefined : "food", // changed
        legendPosition: "middle",
        legendOffset: -40,
      }}
      enableLabel={false}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{
        from: "color",
        modifiers: [["darker", 1.6]],
      }}
      legends={[
        {
          dataFrom: "keys",
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 120,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: "left-to-right",
          itemOpacity: 0.85,
          symbolSize: 20,
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      role="application"
      barAriaLabel={function (e) {
        return e.id + ": " + e.formattedValue + " in country: " + e.indexValue;
      }}
    />
  );
};

export default BarChart;
